import { useSyncExternalStore } from "react";
import {
  getSoundEnabled,
  getSoundVolume,
  setSoundEnabled,
  setSoundVolume,
  subscribeSoundPreference,
} from "./sound.ts";

export function useSoundPreference() {
  const enabled = useSyncExternalStore(
    subscribeSoundPreference,
    getSoundEnabled,
    () => true,
  );
  const volume = useSyncExternalStore(
    subscribeSoundPreference,
    getSoundVolume,
    () => 80,
  );
  return {
    enabled,
    volume,
    setEnabled: setSoundEnabled,
    setVolume: setSoundVolume,
  };
}
